import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useState } from 'react';

type SVHiddenText = {
  text: string;
  visibleCount: number;
  ariaLabel: string;
};

export default function SVHiddenText({
  text,
  visibleCount,
  ariaLabel,
}: SVHiddenText) {
  const [show, setShow] = useState(false);
  const hiddenCount = text.length - visibleCount;
  const hiddenText =
    '*'.repeat(hiddenCount) + String(text).substring(hiddenCount);
  const currentDisplayedText = show ? text : hiddenText;
  const iconSize = { width: 25, height: 25 };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography>{currentDisplayedText}</Typography>
      <IconButton
        aria-live="polite"
        aria-label={`${currentDisplayedText} - ${show ? 'hide' : 'show'} ${ariaLabel}`}
        sx={{ ml: 1 }}
        onClick={() => setShow(!show)}>
        {show ? (
          <Visibility color="primary" sx={iconSize} />
        ) : (
          <VisibilityOff color="primary" sx={iconSize} />
        )}
      </IconButton>
    </Box>
  );
}
